import { render, staticRenderFns } from "./BuscarGrupoEconomico.vue?vue&type=template&id=5b3b856b&scoped=true&"
import script from "./BuscarGrupoEconomico.vue?vue&type=script&lang=js&"
export * from "./BuscarGrupoEconomico.vue?vue&type=script&lang=js&"
import style0 from "./BuscarGrupoEconomico.vue?vue&type=style&index=0&id=5b3b856b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b856b",
  null
  
)

export default component.exports